<template>
  <section class="bg-black pt-96 sm:pt-60">
   <div class="block xlh:hidden lgh:hidden smh:hidden">
     <div
      class="block h-screen sm:h-60"
      id="flying-images"
      data-aos="zoom-in"
      data-aos-duration="9000"
      data-aos-offset="3000"
    >
      &nbsp;
    </div>
    <div class="h-96 s:h-20" id="curtain">
      <div class="whysushi" data-aos="fade-right" data-aos-offset="3000">
        <h1>
          WHY <br />SUSHI<br />
          SHOGUN
        </h1>
      </div>

      <div class="why3" data-aos="fade-down-right" data-aos-offset="3000">
        <img :src="require('../assets/home/why3.jpg')" alt="" />
      </div>
      <div class="why1" data-aos="fade-right" data-aos-offset="2800">
        <img :src="require('../assets/home/why1.jpg')" alt="" />
      </div>
      <div class="why2" data-aos="fade-left" data-aos-offset="2600">
        <img :src="require('../assets/home/why2.jpg')" alt="" />
        <h2 class="sm:hidden">shogun is the highest commander.</h2>
        <p class="sm:hidden">
          At Sushi Shogun, we want to be the flagship that arises when Japanese
          Fusion is mentioned.
        </p>
      </div>
      <div class="hidden sm:block text-white why-m -mt-52">
        <h2>shogun is the highest commander.</h2>
        <p class="text-sm pt-4">
          At Sushi Shogun, we want to be the flagship that arises when Japanese
          Fusion is mentioned.
        </p>
      </div>
    </div>
    </div> 

    <div class="hidden xlh:block lgh:hidden smh:hidden">
     <div
      class="block h-screen sm:h-60"
      id="flying-images"
      data-aos="zoom-in"
      data-aos-duration="9000"
      data-aos-offset="2000"
    >
      &nbsp;
    </div>
    <div class="h-96 s:h-20" id="curtain">
      <div class="whysushi" data-aos="fade-right" data-aos-offset="2200">
        <h1>
          WHY <br />SUSHI<br />
          SHOGUN
        </h1>
      </div>

      <div class="why3" data-aos="fade-down-right" data-aos-offset="2200">
        <img :src="require('../assets/home/why3.jpg')" alt="" />
      </div>
      <div class="why1" data-aos="fade-right" data-aos-offset="2000">
        <img :src="require('../assets/home/why1.jpg')" alt="" />
      </div>
      <div class="why2" data-aos="fade-left" data-aos-offset="2000">
        <img :src="require('../assets/home/why2.jpg')" alt="" />
        <h2 class="sm:hidden">shogun is the highest commander.</h2>
        <p class="sm:hidden">
          At Sushi Shogun, we want to be the flagship that arises when Japanese
          Fusion is mentioned.
        </p>
      </div>
      <div class="hidden sm:block text-white why-m -mt-52">
        <h2>shogun is the highest commander.</h2>
        <p class="text-sm pt-4">
          At Sushi Shogun, we want to be the flagship that arises when Japanese
          Fusion is mentioned.
        </p>
      </div>
    </div>
    </div> 

   <div class="hidden xlh:hidden lgh:block smh:hidden">
     <div
      class="block h-screen sm:h-60"
      id="flying-images"
      data-aos="zoom-in"
      data-aos-duration="9000"
      data-aos-offset="2300"
    >
      &nbsp;
    </div>
    <div class="h-96 s:h-20" id="curtain">
      <div class="whysushi" data-aos="fade-right" data-aos-offset="2500">
        <h1>
          WHY <br />SUSHI<br />
          SHOGUN
        </h1>
      </div>

      <div class="why3" data-aos="fade-down-right" data-aos-offset="2500">
        <img :src="require('../assets/home/why3.jpg')" alt="" />
      </div>
      <div class="why1" data-aos="fade-right" data-aos-offset="2300">
        <img :src="require('../assets/home/why1.jpg')" alt="" />
      </div>
      <div class="why2" data-aos="fade-left" data-aos-offset="2300">
        <img :src="require('../assets/home/why2.jpg')" alt="" />
        <h2 class="sm:hidden">shogun is the highest commander.</h2>
        <p class="sm:hidden">
          At Sushi Shogun, we want to be the flagship that arises when Japanese
          Fusion is mentioned.
        </p>
      </div>
      <div class="hidden sm:block text-white why-m -mt-52">
        <h2>shogun is the highest commander.</h2>
        <p class="text-sm pt-4">
          At Sushi Shogun, we want to be the flagship that arises when Japanese
          Fusion is mentioned.
        </p>
      </div>
    </div>
    </div> 

      <div class="hidden xlh:hidden lgh:hidden smh:block">
     <div
      class="block h-screen sm:h-60"
      id="flying-images"
      data-aos="zoom-in"
      data-aos-duration="9000"
    >
      &nbsp;
    </div>
    <div class="h-96 s:h-20" id="curtain">
      <div class="whysushi" data-aos="fade-right">
        <h1>
          WHY <br />SUSHI<br />
          SHOGUN
        </h1>
      </div>

      <div class="why3" data-aos="fade-down-right" data-aos-offset="0">
        <img :src="require('../assets/home/why3.jpg')" alt="" />
      </div>
      <div class="why1" data-aos="fade-right" data-aos-offset="0">
        <img :src="require('../assets/home/why1.jpg')" alt="" />
      </div>
      <div class="why2" data-aos="fade-left" data-aos-offset="0">
        <img :src="require('../assets/home/why2.jpg')" alt="" />
        <h2 class="sm:hidden">shogun is the highest commander.</h2>
        <p class="sm:hidden">
          At Sushi Shogun, we want to be the flagship that arises when Japanese
          Fusion is mentioned.
        </p>
      </div>
      <div class="hidden sm:block text-white why-m -mt-52">
        <h2>shogun is the highest commander.</h2>
        <p class="text-sm pt-4">
          At Sushi Shogun, we want to be the flagship that arises when Japanese
          Fusion is mentioned.
        </p>
      </div>
    </div>
    </div> 
  </section>
</template>

<script>
export default {
  data() {
    return {
      offset: 0
    };
  },

  methods: {
    getOffSet() {
      let vw = window.innerWidth;
      this.offset = Math.ceil(this.$store.panaromaHeight - 0.2 * vw);
      console.log(this.offset);
    }
  },

  mounted() {
    //window.addEventListener("load", this.getOffSet);
    //setTimeout(this.getOffSet, 2000);
  }
};
</script>

<style scoped>
#curtain {
  position: relative;
  top: -140vh;
}
.whysushi h1 {
  width: 25%;
  margin: 0 0 0 5%;
  height: auto;
  font-family: Times;
  font-style: normal;
  font-weight: normal;
  font-size: 4rem;
  line-height: 70px;
  /* or 97% */

  letter-spacing: 0.05em;
  text-transform: uppercase;

  /* white */

  color: #ffffff;
}
.why2 h2 {
  width: 20%;
  height: auto;
  font-family: Times;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 32px;
  /* or 133% */

  text-align: right;
  letter-spacing: 0.05em;
  text-transform: uppercase;

  /* white */

  color: #ffffff;
}

.why2 p {
  width: 20%;
  height: auto;
  font-family: avenirLight;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  text-align: right;
  letter-spacing: 0.02em;

  /* white */

  color: #ffffff;
}

#flying-images {
  background: url("~@/assets/home/bg-logo.png") no-repeat center center;
  overflow: hidden;
  background-size: 45%;
}

.why1 {
  position: relative;
  left: 10%;
  top: -20vh;
}

.why1 img {
  max-width: 40%;
}

.why2 {
  position: relative;
  top: -78vh;
  left: 60%;
}
.why2 img {
  width: 20% !important;
}
.why3 img {
  max-width: 50%;
}
.why3 {
  position: relative;
  left: 40%;
  z-index: 10;
}

@media only screen and (max-width: 639px) {
  #curtain {
    top: -50vh;
  }
  #flying-images {
    background-size: 70%;
  }
  .whysushi h1 {
    font-size: 2rem;
    line-height: 2.5rem;
  }
  .why1 img {
    max-width: 50%;
  }
  .why3 img {
    max-width: 30%;
    padding-bottom: 15vh;
  }
  .why2 {
    position: relative;
    top: -38vh;
    left: 65%;
  }
  .why2 img {
    width: 25% !important;
  }
  .why-m h2 {
    font-family: times;
    text-align: center;
    text-transform: uppercase;
    width: 80%;
    margin: auto;
  }
  .why-m p {
    font-family: avenirLight;
    text-align: center;
    text-transform: uppercase;
    width: 80%;
    margin: auto;
  }
}
</style>